module.exports = __webpack_public_path__ + "static/banner-react-c78988f906ea703cf88123233d022ef1.svg";